module.exports = function() {

	var self = this;

	var range = _.range(this.pagination.numPages)

	//console.log(this.pagination.numPages);
	//console.log(range);

	if(range.length > 10) {

		var numDrop = this.pagination.numPages-2;
		

		//var first = _.dropRightWhile(range, function(o) { return o != 0; });
		var first = _.dropRight(range, numDrop);
		var last = _.drop(range, numDrop);

		var activePage = parseInt(this.pagination.activePage);

		var middle = _.range(activePage-3, activePage+2);

		//console.log("first "+first);
		//console.log("midle "+middle);
		//console.log("last "+last);

		var union = _.union(first, middle, last);

		//console.log('after union '+union);

		var filter = _.remove(union, function(n) {
			return n >= 0 && n < self.pagination.numPages;
		});

		//console.log('after filter '+filter);


		return filter;


	} else {
		return range;
	}

	
}